import { Check } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

const TIERS = [
  { value: 'basic', title: 'Basic', price: 'Free', features: ['Basic listing', 'Message customers', 'Accept bookings', '10% platform fee on sales'] },
  { value: 'better', title: 'Better Visibility', price: '$25/mo', features: ['Higher search ranking', 'Priority support', 'Featured recommendations', 'Advanced analytics'] },
  { value: 'priority', title: 'Priority Placement + Tools', price: '$50/mo', features: ['Front-page placement', 'Ad eligibility', 'Premium badge', 'Website builder', 'All Better tier features'] },
];

/** Step 3 — Membership tier + T&Cs agreement. */
export default function Step3Membership({
  membershipLevel,
  setMembershipLevel,
  agreedToVendorTerms,
  setAgreedToVendorTerms,
}) {
  return (
    <div className="space-y-6">
      <p className="text-stone-400 font-outfit text-center mb-8">
        Choose your membership level. You can change this anytime.
      </p>
      <RadioGroup value={membershipLevel} onValueChange={setMembershipLevel} className="space-y-4">
        {TIERS.map((tier) => (
          <div key={tier.value}>
            <RadioGroupItem value={tier.value} id={tier.value} className="peer sr-only" />
            <Label
              htmlFor={tier.value}
              className={`flex items-start gap-4 p-6 rounded-2xl border cursor-pointer transition-colors ${
                tier.value === 'priority' ? 'border-yellow-400/50 bg-yellow-400/5' : 'border-stone-800 hover:border-stone-700'
              } peer-data-[state=checked]:border-yellow-400 peer-data-[state=checked]:bg-yellow-400/10`}
              data-testid={`membership-${tier.value}`}
            >
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="font-syne text-lg font-bold text-stone-200">{tier.title}</span>
                  <span className="font-mono text-yellow-400">{tier.price}</span>
                </div>
                <ul className="space-y-1">
                  {tier.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-2 text-stone-400 text-sm font-outfit">
                      <Check className="w-4 h-4 text-turquoise-400" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </Label>
          </div>
        ))}
      </RadioGroup>

      <label className="flex items-start gap-3 mt-6 cursor-pointer bg-stone-800/50 rounded-xl p-4 border border-stone-700" data-testid="vendor-terms-label">
        <input
          type="checkbox"
          checked={agreedToVendorTerms}
          onChange={(e) => setAgreedToVendorTerms(e.target.checked)}
          className="mt-1 w-4 h-4 rounded border-stone-600 bg-stone-900 text-yellow-400 focus:ring-yellow-400"
          data-testid="vendor-terms-checkbox"
        />
        <span className="text-stone-400 text-xs font-outfit leading-relaxed">
          I agree to the{' '}
          <a href="/legal/terms-of-service" target="_blank" rel="noreferrer" className="text-yellow-400 hover:underline">Terms of Service</a>,{' '}
          <a href="/legal/vendor-agreement" target="_blank" rel="noreferrer" className="text-yellow-400 hover:underline">Vendor Agreement</a>,{' '}
          <a href="/legal/privacy-policy" target="_blank" rel="noreferrer" className="text-yellow-400 hover:underline">Privacy Policy</a>, and{' '}
          <a href="/legal/independent-contractor-policy" target="_blank" rel="noreferrer" className="text-yellow-400 hover:underline">Independent Contractor Policy</a>.
          I understand that EntrepreNatives charges a flat 10% seller fee on all transactions. Buyers pay no platform fees.
        </span>
      </label>
    </div>
  );
}
